import {
  IoIosCheckbox,
  IoMdBuild,
  IoMdCash,
  IoMdStats,
  IoMdTimer,
} from "react-icons/io";
import {
  COMPANY_COMMITMENTS,
  COMPETENT_AND_TRAINED_CREW,
  COMPETENT_AND_TRAINED_CREW_TEXT,
  CONTINUOUS_MONITORING,
  CONTINUOUS_MONITORING_TEXT,
  COST_EFFECTIVE_OPERATIONS,
  COST_EFFECTIVE_OPERATIONS_TEXT,
  REGULAR_AUDITS_AND_INSPECTIONS,
  REGULAR_AUDITS_AND_INSPECTIONS_TEXT,
  RESPONSIVE_AND_PROFESSIONAL_SERVICE,
  RESPONSIVE_AND_PROFESSIONAL_SERVICE_TEXT,
} from "../../constants/translations";

const CommitmentBox = ({ icon, title, text }) => {
  return (
    <div className="commitment-wrapper">
      <span className="commitment-header">
        <span className="commitment-icon">{icon}</span>
        <h3 className="commitment-title">{title}</h3>
      </span>
      <p className="commitment-text">{text}</p>
    </div>
  );
};

const CompanyCommitments = () => {
  const commitments = [
    {
      id: 0,
      title: COMPETENT_AND_TRAINED_CREW,
      icon: <IoMdTimer />,
      text: COMPETENT_AND_TRAINED_CREW_TEXT,
    },
    {
      id: 1,
      title: CONTINUOUS_MONITORING,
      icon: <IoMdStats />,
      text: CONTINUOUS_MONITORING_TEXT,
    },
    {
      id: 2,
      title: RESPONSIVE_AND_PROFESSIONAL_SERVICE,
      icon: <IoIosCheckbox />,
      text: RESPONSIVE_AND_PROFESSIONAL_SERVICE_TEXT,
    },
    {
      id: 3,
      title: REGULAR_AUDITS_AND_INSPECTIONS,
      icon: <IoMdBuild />,
      text: REGULAR_AUDITS_AND_INSPECTIONS_TEXT,
    },
    {
      id: 4,
      title: COST_EFFECTIVE_OPERATIONS,
      icon: <IoMdCash />,
      text: COST_EFFECTIVE_OPERATIONS_TEXT,
    },
  ];
  return (
    <section className="company-commitments-wrapper">
      <div className="grid-place mm-width">
        <div className="title-wrapper">
          <h2 className="section-title">{COMPANY_COMMITMENTS}</h2>
        </div>
        {commitments.map((c, index) => (
          <CommitmentBox {...c} key={index} />
        ))}
      </div>
    </section>
  );
};

export default CompanyCommitments;
